import { HeTimesheetsAdd } from "@/features"

const HeTimesheetsAddPage = () => {
  return <HeTimesheetsAdd />
}

export default HeTimesheetsAddPage